import React from "react";
import { Col, Card, CardImg, CardBody, CardTitle, CardText } from "reactstrap";
import ReactHtmlParser from "react-html-parser";

import transport from "../../assets/img/icons/transport.jpeg"



export const ItemTransport = (props) => {
  const item = props.item;

  let titleItem = item.name;
  if (!titleItem) {
    titleItem = item.title;
  }

  let numberCols = props.ncol;
  if (!numberCols) {
    numberCols = "4";
  }


  item.description = `
  <b> Sector: </b> ${item.sector}
  <br>
  <b> Tipo de Transporte: </b> ${item.type_transport_name}
  <br>
  <b> Calle Principal : </b> ${item.main_street}
  <br>
  <b> Calle Secundaria : </b> ${item.cross} 
   `;

  return (
    <Col sm={numberCols}>
      <Card className="card-item">
        <CardImg
          alt="Card image cap"
          src={transport}
          top
          width="100%"
          height="280px"
        />
        <CardBody>
          <CardTitle tag="h5">{titleItem}</CardTitle>
          <CardText>
            {item.description.length > 250
              ? `${item.description.substring(0, 250)} ...`
              : ReactHtmlParser(item.description)}
          </CardText>
        </CardBody>
      </Card>
    </Col>
  );
};
